import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translationEn from './locales/en/translation.json'
import translationDe from './locales/de/translation.json'
import translationFr from './locales/fr/translation.json'
import translationEs from './locales/es/translation.json'
// backend: {
//   loadPath: 'http://localhost:3000/locales/{{lng}}/{{ns}}.json',
// }, // your backend options.
// // More info here: https://github.com/i18next/i18next-http-backend
// preload: ['en', 'de', 'fr', 'es'],

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    // we init with resources
    resources: {
      en: {
        translations: translationEn,
      },
      de: {
        translations: translationDe,
      },
      fr: {
        translations: translationFr,
      },
      es: {
        translations: translationEs,
      },
    },
    fallbackLng: 'de',
    // debug: true,
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys
    nsSeparator: false,
    interpolation: {
      formatSeparator: ',',
    },

    react: {
      useSuspense: true,
    },
  })
// i18n.changeLanguage('cimode')

export default i18n

export const getCurrentLangISO = () => {
  // iso639_2
  const LANGS = { en: 'eng', de: 'ger', fr: 'fre', es: 'spa' }
  return LANGS[i18n.resolvedLanguage]
}
